import { FC, useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useStore, connect } from "src/store/connect";
import { Typography, Switch, Divider } from "@material-ui/core";

interface DocumentValidationFormProps {
  targetBlock: Block;
  onChangeValidationInput: (newValidationInput: ValidationInput) => void;
}

const DocumentValidationForm: FC<DocumentValidationFormProps> = ({
  targetBlock,
  onChangeValidationInput,
}) => {
  const classes = useStyles();
  const state = useStore();
  const emptyValidationForm: ValidationInput = {
    faceValidation: {
      variableID: "",
      default: false,
    },
  };
  const [documentValidationForm, setDocumentValidationForm] =
    useState<ValidationInput>(
      targetBlock.data.validationInput || (() => emptyValidationForm)
    );

  const onChangeFanceValidation = () => {
    const newValidationInput: ValidationInput = {
      ...documentValidationForm,
      faceValidation: {
        variableID: "",
        default: !documentValidationForm.faceValidation.default,
      },
    };
    setDocumentValidationForm(newValidationInput);
    onChangeValidationInput(newValidationInput);
  };

  return (
    <div className={classes.root}>
      <div className={classes.fieldContainer}>
        <span className={classes.fieldSeparator} />
        <Typography className={classes.title}>Validación de Rostro</Typography>
        <Switch
          checked={documentValidationForm.faceValidation.default as boolean}
          onChange={onChangeFanceValidation}
          classes={{
            switchBase: classes.switchBase,
          }}
        />
      </div>

      <Divider className={classes.divider} />
    </div>
  );
};

DocumentValidationForm.defaultProps = {};

export default connect(DocumentValidationForm);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: "8px",
  },
  title: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
  },
  fieldContainer: {
    display: "grid",
    alignItems: "center",
    gridTemplateColumns: "1fr 10fr 2fr",
    margin: "0 0 16px 0",
  },
  fieldSeparator: {
    width: "8px",
    height: "38px",
    borderRadius: "2.5px",
    backgroundColor: "#64DFEE",
  },
  divider: {
    margin: "20px 0",
  },
  switchBase: {
    color: "#fff",
    "&.Mui-disabled": {
      color: "#fff",
    },
    "&.Mui-checked": {
      color: "#12d67d",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#dbdbdb",
    },
  },
}));
